import { Grid, InputLabel, Select, Input, MenuItem, FormControlLabel, Switch, Typography } from '@material-ui/core';
import CustomMaskedInput from 'components/MaskedInput';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { run } from 'validations/ruleRunner';

import Validations from './validations';

import type { DispatchProp } from 'react-redux';

const CAIXA_PACOTE = '1',
  ROLO_PRISMA = '2';
const PAC = '41106',
  SEDEX = '40010',
  SEDEX10 = '40215';

interface IProps {
  delivery: any;
  enabledValidation: boolean;
  onEdit?: () => void;
}

interface IStates {
  showErrors: boolean;
  validationErrors: any;
}

interface IProps extends DispatchProp<any> {
  delivery: any;
  enabledValidation: boolean;
}

class Correios extends Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      showErrors: false,
      validationErrors: run(props.delivery, Validations),
    };
  }

  errorFor = (field: any) => {
    return this.state.validationErrors[field] || '';
  };

  isValid = (field: any) => {
    return this.state.validationErrors[field] ? true : false;
  };

  handleChange(prop: string, value: any) {
    let { delivery } = this.props;
    delivery[prop] = value;
    if (this.props.onEdit) {
      this.props.onEdit();
    }
    this.props.dispatch({ type: 'CHANGE_PHYSICAL_DELIVERY', delivery });
  }

  handleChangeType = (checked: any, value: any) => {
    let { delivery } = this.props;
    if (checked) {
      delivery['delivery_options'] = delivery['delivery_options'] || [];
      delivery['delivery_options'].push(value);
    } else {
      delivery['delivery_options'] = delivery['delivery_options'].filter((item: any) => item !== value);
    }
    if (this.props.onEdit) {
      this.props.onEdit();
    }
    this.props.dispatch({ type: 'CHANGE_PHYSICAL_DELIVERY', delivery });
  };

  componentDidUpdate(prevProps: IProps) {
    const { delivery } = this.props;
    if (delivery !== prevProps.delivery) {
      let newState = { ...this.state };
      newState.validationErrors = run(delivery, Validations);
      this.setState(newState);
    }
  }
  render() {
    const { delivery } = this.props;
    const pac = delivery.delivery_options ? delivery.delivery_options.includes(PAC) : false;
    const sedex = delivery.delivery_options ? delivery.delivery_options.includes(SEDEX) : false;
    const sedex10 = delivery.delivery_options ? delivery.delivery_options.includes(SEDEX10) : false;

    return (
      <>
        <Grid item xs={12} md={4}>
          <FormControlLabel
            label='PAC'
            control={
              <Switch id='product-delivery-pac' color='default' checked={pac} onChange={(e: any) => this.handleChangeType(e.target.checked, PAC)} />
            }
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <FormControlLabel
            label='SEDEX'
            control={
              <Switch
                id='product-delivery-sedex'
                color='default'
                checked={sedex}
                onChange={(e: any) => this.handleChangeType(e.target.checked, SEDEX)}
              />
            }
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <FormControlLabel
            label='SEDEX 10'
            control={
              <Switch
                id='product-delivery-sedex-10'
                color='default'
                checked={sedex10}
                onChange={(e: any) => this.handleChangeType(e.target.checked, SEDEX10)}
              />
            }
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Typography color='error'>{this.isValid('delivery_options') ? `${this.errorFor('delivery_options')}` : ''}</Typography>
        </Grid>

        <Grid item xs={12}>
          <InputLabel>Formato de embalagem</InputLabel>
          <Select
            id='format'
            fullWidth
            value={delivery.format}
            input={<Input disableUnderline fullWidth />}
            onChange={(value: any) => this.handleChange('format', value.target.value)}
          >
            <MenuItem value={CAIXA_PACOTE}>Caixa/Pacote</MenuItem>
            <MenuItem value={ROLO_PRISMA}>Rolo/Prisma</MenuItem>
          </Select>
        </Grid>
        <Grid item xs={12}>
          <CustomMaskedInput
            label='CEP de origem'
            fullWidth={true}
            disableUnderline
            id='zip_code'
            mask='postalCode'
            helperText={this.isValid('zip_code') ? this.errorFor('zip_code') : null}
            error={this.isValid('zip_code')}
            value={delivery.zip_code}
            onChange={(value: any) => this.handleChange('zip_code', value)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <CustomMaskedInput
            label='Peso'
            fullWidth={true}
            disableUnderline
            id='weight'
            mask='money'
            helperText={this.isValid('weight') ? this.errorFor('weight') : null}
            error={this.isValid('weight')}
            value={delivery.weight}
            onChange={(value: any) => this.handleChange('weight', value)}
            InputLabelProps={{
              shrink: true,
            }}
            endAdornment='kg'
          />
        </Grid>
        {delivery.format == CAIXA_PACOTE && (
          <Grid item xs={12}>
            <CustomMaskedInput
              label='Altura'
              fullWidth={true}
              disableUnderline
              id='height'
              mask='number'
              helperText={this.isValid('height') ? this.errorFor('height') : 'A altura não pode ser maior que 105cm ou menor que 2cm'}
              error={this.isValid('height')}
              value={delivery.height}
              onChange={(value: any) => this.handleChange('height', value)}
              InputLabelProps={{
                shrink: true,
              }}
              endAdornment='cm'
            />
          </Grid>
        )}
        {delivery.format != ROLO_PRISMA && (
          <Grid item xs={12}>
            <CustomMaskedInput
              label='Largura'
              fullWidth={true}
              disableUnderline
              id='width'
              mask='number'
              helperText={this.isValid('width') ? this.errorFor('width') : 'A largura não pode ser maior que 105cm ou menor que 11cm'}
              error={this.isValid('width')}
              value={delivery.width}
              onChange={(value: any) => this.handleChange('width', value)}
              InputLabelProps={{
                shrink: true,
              }}
              endAdornment='cm'
            />
          </Grid>
        )}
        <Grid item xs={12}>
          <CustomMaskedInput
            label='Comprimento'
            fullWidth={true}
            disableUnderline
            id='length'
            mask='number'
            helperText={this.isValid('length') ? this.errorFor('length') : 'O comprimento não pode ser maior que 105cm ou menor que 16cm'}
            error={this.isValid('length')}
            value={delivery.length}
            onChange={(value: any) => this.handleChange('length', value)}
            InputLabelProps={{
              shrink: true,
            }}
            endAdornment='cm'
          />
        </Grid>

        {delivery.format === ROLO_PRISMA && (
          <Grid item xs={12}>
            <CustomMaskedInput
              label='Diâmetro'
              fullWidth={true}
              disableUnderline
              id='diameter'
              mask='number'
              helperText={this.isValid('diameter') ? this.errorFor('diameter') : 'O diâmetro não pode ser maior que 91cm ou menor que 5cm'}
              error={this.isValid('diameter')}
              value={delivery.diameter}
              onChange={(value: any) => this.handleChange('diameter', value)}
              InputLabelProps={{
                shrink: true,
              }}
              endAdornment='cm'
            />
          </Grid>
        )}
      </>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    delivery: state.components.physicalDelivery,
  };
}

export default connect(mapStateToProps)(Correios);
